import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-36f458dc")

_pushScopeId("data-v-36f458dc")
const _hoisted_1 = { class: "wf-map" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "wf-map-caption my-0 px-3 text-center" }, [
  /*#__PURE__*/_createTextVNode(" Мы представлены во всех уголках России"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" благодаря сотням наших агентств ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      id: "map",
      style: [{"width":"100%"}, {
      height: _ctx.isMobile ? '50vh' : '30vh',
    }]
    }, null, 4),
    _hoisted_2
  ]))
})